/* global axios */
import ApiClient from './ApiClient';

class MetaCampaignsAdAccountsAPI extends ApiClient {
  constructor() {
    super('meta_campaigns/ad_accounts', { accountScoped: true });
  }

  oauthAdAccounts(shortLivedToken) {
    return axios.post(`${this.url}/oauth_ad_accounts`, {
      short_lived_token: shortLivedToken,
    });
  }

  lookupAdAccounts(accessToken) {
    return axios.post(`${this.url}/oauth_ad_accounts`, {
      access_token: accessToken,
    });
  }

  reconnect(id, accessToken) {
    return axios.post(`${this.url}/${id}/reconnect`, {
      access_token: accessToken,
    });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }

  backfill(id, since, until) {
    return axios.post(`${this.url}/${id}/backfill`, { since, until });
  }
}

export default new MetaCampaignsAdAccountsAPI();
